<template>
  <table class="table">
    <tr>
      <th>{{ $t("dmp.name")}}</th>
      <td class="fw-bold">{{ data.name }}</td>
    </tr>
    <tr>
      <th>{{ $t("dmp.host")}}</th>
      <td class="fw-bold">{{ data.panel_host }}</td>
    </tr>
    <tr>
      <th>{{ $t("dmp.panel_mac_addr")}}</th>
      <td class="fw-bold">{{ data.panel_mac_addr }}</td>
    </tr>
    <tr>
      <th>{{ $t("dmp.panel_model")}}</th>
      <td class="fw-bold">{{ data.panel_model }}</td>
    </tr>
    <tr>
      <th>{{ $t("dmp.panel_serial_num")}}</th>
      <td class="fw-bold">{{ data.panel_serial_num }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props:{
    data: {
      type: Array | Object
    }
  }
}
</script>
